import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { Link, useLocation } from "react-router-dom";

const options = { threshold: 0.5 };

class MainPixelogCard extends Component {

  constructor(props) {
    super(props);

    const { id, dataKey, uid, fps, frames, nick, winUid, likes, created_at, type, name } = this.props;

    this.imgRef = React.createRef();

      var year = created_at.substring(2,4);
      var month = created_at.substring(5,7);
      var day = created_at.substring(8,10);

      // ai 이미지경로
      if(type == 1){
          var imgSrc = `/outputs/txt2img/20${year}-${month}-${day}/${dataKey}.png`;
      }else{
          var imgSrc = `/upload/${year}/${month}/${day}/${dataKey}.png`;
      }
    var gifSrc = `/upload/${year}/${month}/${day}/${dataKey}.gif`;

    this.state = {
      isHovered: false,
      //baseImg: '/img/pixelog-gif.gif',
      baseImg: '/img/pixelog-loading-gradation-bg.gif',
      stateImg: imgSrc,
      stateGif: gifSrc
    };

    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
  }

  handleMouseOver() {

    const { stateGif } = this.state;

    this.setState({
      baseImg: stateGif
    });
  }

  handleMouseOut() {

    const { stateImg } = this.state;

    this.setState({
      baseImg: stateImg
    });
  }

  likesOnclick = () => {
    const { dataKey, winUid, id, likes} = this.props;
    btnLike(dataKey, winUid);

    // likes 값을 토글
    const newLikes = likes === '1' ? '0' : '1';
    const changeValues = {"likes":newLikes, "id":id};
    // 변경된 likes 값을 부모 컴포넌트로 전달
    this.props.onLikeChange(changeValues);
  }

  componentDidMount() {
    const observer = new IntersectionObserver(this.callback, options);
    observer.observe(this.imgRef.current);
  }

  callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        entry.target.src = entry.target.dataset.src;
      }
    });
  };


  render(){

    const { dataKey, uid, fps, frames, nick, winUid, likes, created_at, name } = this.props;

    var href1 = `/user/${uid}/${dataKey}`;
    var href2 = `/pixelog/edit/${dataKey}`;

    var likesSpanId = `id${dataKey}`;

    return (

          <div className="grid-item card-preview-container shadow" style={{"position":"relative"}}>

            {
              frames > 1 && (<span className="gif-icon">GIF</span>)
            }

            {
              likes > 0 
                ? 
                (
                  <span id={likesSpanId} onClick={this.likesOnclick} className="cursor-pointer likes-icon"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-heart-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg></span>)
                : (<span id={likesSpanId} onClick={this.likesOnclick} className="cursor-pointer likes-no-icon"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-heart-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg></span>)
            }
            <Link style={{"color":"black"}}
                to={{
                pathname: `/pixelog/view/${dataKey}`,
                state: {
                  likes: likes,
                  test : 'asdasdasd',
                  // propkey: dataKey,
                  // created_at: created_at,
                  // fps: fps,
                }
            }}>

            {
              frames > 1 
              ?
              (
                <img
                  //style={{"backgroundColor":"#f0f0f0"}}
                  className="animated-preview-widget"
                  src={this.state.baseImg}
                  data-src={this.state.stateImg}
                  onMouseOver={this.handleMouseOver} 
                  onMouseOut={this.handleMouseOut}
                  ref={this.imgRef}
                  alt={name}
                />
              )
              :
              (
                <img
                  //style={{"backgroundColor":"#f0f0f0"}}
                  className="animated-preview-widget"
                  src={this.state.baseImg}
                  data-src={this.state.stateImg}
                  ref={this.imgRef}
                  alt={name}
                />
              )
            }
            </Link> 
            <div className="card-preview-actions">
              <a className="card-preview-action right bold important text-truncate" style={{"maxWidth":"80px"}} href={href1}>by {nick}</a>
              <a className="card-preview-pixelog left bold important" href={href2}>PIXELOG</a>
            </div>
          </div>
        
    ); //return
  }
}

export default MainPixelogCard;